angular.module('core')
    .component('emailDisplay', {
        bindings: {
            value: '<',
            showMailLink: '<?',
            showCopyAction: '<?'
        },
        templateUrl: 'app/utils/email-input/email-display.html',
        controller: function () {
            this.$onInit = () => {
                this.showMailLink = this.showMailLink !== false
                this.showCopyAction = this.showCopyAction !== false
            }

            this.$onChanges = () => {
                this.displayValue = this.normalizeValue(this.value)
            }

            this.normalizeValue = value => {
                if (value === null || value === undefined) {
                    return ''
                }
                return String(value).trim()
            }

            this.hasValue = () => !!this.displayValue
        }
    })
